import { graphql } from 'gql';

export const catalogUERBaseCostHistoryWorkScopesGql = graphql(`
    query catalogUERBaseCostHistoryWorkScopes($catalogUniqueId: String!, $historyRecordId: Long!) {
        catalogUERBaseCostHistoryWorkScopes(catalogUniqueId: $catalogUniqueId, historyRecordId: $historyRecordId) {
            data {
                counts {
                    newScopesCount
                    deletedScopesCount
                    updatedScopesCount
                }
                workScopeItems {
                    updateUerDate
                    number
                    workScopeNumberCng
                    name
                    workScopeNameCng
                    changeType
                }
            }
        }
    }
`);
